<template>
    <div class="listmain "> 
        <h1 class="firTitle">词典</h1>
        <p>同一领域的术语集合,如，城市词典，歌手词典等。应用于用户表达信息的提取和语义槽的调用
       </p>
        <h5 class="codeTitle">添加词条</h5>
        <p>填写词是用户在常用表达中期望被识别的词，同义词是填写词对应的相同含义的词，常用表达中被识别后会转换为填写词，多个同义词用逗号隔开，可以不输入此项。
如城市词典中。 
       </p>
            <table>
                <tr>
                  <th>填写词</th>
                  <th>同义词</th>
                
                </tr>
                <tr>
                  <td>北京</td>
                  <td>帝都，北平，首都</td>
                  
                </tr>
                <tr>
                  <td>上海</td>
                  <td>魔都</td>                 
                </tr>
                 <tr>
                  <td>深圳</td>
                  <td></td>                 
                </tr>

          </table>


       
         <h5 class="codeTitle">批量上传</h5>
        <p>用户可通过批量导入导出功能完成词典的批量编辑操作.批量导入会对文件做导入检测
       <br>	文件大小:不超过10M
       <br>文件类型:CSV文件
        <br>文件编码:utf8编码
       </p>
        <h5 class="codeTitle">模板:</h5>
         <table>
                <tr>
                  <th>填写词</th>
                  <th>同义词</th>
                  <th></th>
                  <th></th>
                
                </tr>
                <tr>
                  <td>北京</td>
                  <td>北平</td>
                   <td>帝都</td>
                  <td>首都</td>
                  
                </tr>
                <tr>
                  <td>上海</td>
                  <td>魔都</td>
                  <td></td>
                  <td></td>                       
                </tr>
                 <tr>
                  <td>深圳</td>
                  <td></td> 
                  <td></td>  
                  <td></td>                  
                </tr>

          </table>


        <h5 class="codeTitle">导出</h5>
        <p>点击导出词典，将会导出utf8编码的CSV文件，用户可以进行编辑
       </p>
        <h5 class="codeTitle">系统字典</h5>
        <p>开放平台为用户提供了高频使用的词典，如城市词典，歌手词典，开发者可通过添加直接使用
       </p>
       


    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>

  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }



  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle{
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle{
      font-weight: bold;
      line-height: 26px;
    }
    pre{
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>




// WEBPACK FOOTER //
// src/components/tutor/zygn_zd.vue